import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBOMmk-1XYJrIa8VLQtuD7M-mCuMCG0aZ0",
  authDomain: "qrsalve-ec277.firebaseapp.com",
  projectId: "qrsalve-ec277",
  storageBucket: "qrsalve-ec277.appspot.com",
  messagingSenderId: "210666194057",
  appId: "1:210666194057:web:fe9ee9732acdd128ca3258"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };